export default __webpack_public_path__ + "static/media/655-icon.c0bd44c4.svg";